import React from 'react';
import { FaRegMap } from 'react-icons/fa';
import { RiFileWarningLine } from 'react-icons/ri';
import { GrPin } from "react-icons/gr";

const GrPinComponent = GrPin as any;

const FaRegMapComponent = FaRegMap as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const RiFileWarningLineComponent =
  RiFileWarningLine as unknown as React.ComponentType<{
    size?: number | string;
    className?: string;
  }>;

interface RecentActivityItem {
  id: number;
  activity: string;
  time: string;
  badgeColor: string;
  textColor?: string;
  icon?: string;
}

interface RecentActivitiesProps {
  recentactivitiesData: any[];
}

const RecentActivities: React.FC<RecentActivitiesProps> = ({
  recentactivitiesData,
}) => {
  const hasData = recentactivitiesData && recentactivitiesData.length > 0;

  // Handle both raw API data and dummy data
  const formattedData: RecentActivityItem[] = recentactivitiesData.map((item, index) => {
    if (item.title && item.timestamp) {
      return {
        id: index,
        activity: item.title,
        time: new Date(item.timestamp).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
        }),
        badgeColor: '#7A52CCCC',
        textColor: '#7C3AED',
        icon: '📌'
      };
    }
    return {
      id: item.id || index,
      activity: item.activity || item.title || 'Activity',
      time: item.time || 'Just now',
      badgeColor: item.badgeColor || '#7A52CCCC',
      textColor: item.textColor,
      icon: item.icon || '📌'
    };
  });

  return (
    <div
      className='bg-white p-4 rounded-lg mb-6 shadow-sm border'
      style={{ minWidth: '250px' }}
    >
      <h3
        className='text-lg font-semibold mb-4 text-gray-800'
        style={{ color: '#0D121A', fontSize: '20px' }}
      >
        Recent Activities
      </h3>

      {hasData ? (
        <div
          className='overflow-y-auto pr-2 custom-scrollbar'
          style={{
            maxHeight: '320px',           // Shows ~5 items comfortably
            scrollbarWidth: 'thin',
            scrollbarColor: '#CBD5E1 #F8FAFC',
          }}
        >
          <ul className='space-y-4'>
            {formattedData.map((item) => (
              <li
                key={item.id}
                className='flex items-center justify-between border-b last:border-b-0 pb-3 last:pb-0'
              >
                <div className='flex items-start'>
                  <span
                    className='flex items-center justify-center mr-3'
                    style={{
                      width: '25px',
                      height: '25px',
                      backgroundColor: item.badgeColor,
                      borderRadius: '5px',
                      color: 'white',
                      flexShrink: 0,
                    }}
                  >
                    <GrPinComponent size={14} />
                  </span>
                  <div style={{ marginTop: '-2px' }}>
                    <span
                      className='text-sm text-gray-700'
                      style={{
                        color: '#0D121A',
                        fontWeight: 'bold',
                        fontSize: '14px',
                      }}
                    >
                      {item.activity}
                    </span>
                    <p
                      className='text-xs font-medium'
                      style={{ color: '#93A0B3', fontSize: '12px' }}
                    >
                      {item.time}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center text-gray-500 py-16'>
          <RiFileWarningLineComponent
            size={50}
            className='mb-4 text-gray-400'
          />
          <p
            className='font-semibold'
            style={{ color: '#0D121A', fontSize: '16px' }}
          >
            No activity yet.
          </p>
          <p
            className='text-sm mt-1'
            style={{ color: '#93A0B3', fontSize: '14px' }}
          >
            Once you send your first campaign, real-time updates will show here.
          </p>
        </div>
      )}
    </div>
  );
};

export default RecentActivities;